define('util/privileged/ModelChangeTracker',[
    'lib/knockout',
    'lib/lodash4'
], function (ko, _) {
    'use strict';

    /**
     * Really basic change tracking.  By default it just compares the JSON you'd be sending to the server
     * against the JSON at the time you create the tracking object.  If they differ, then somethingHasChanged
     * will return true.
     *
     * @param {object} The object to track changes on
     * @param {function} (Optional) Your own custom hashing function that will be passed objectToTrack.  If not
     * specified, then the default is used, which expects a .unwrap function on the objectToTrack that produces
     * a unwrapped version of the javascript object.  (See ObservableModel.unwrap)
     *
     * @returns {{somethingHasChanged: {Boolean}, markCurrentStateAsClean}}
     * @constructor
     */
    var ModelChangeTracker = function (objectToTrack, hashFunction) {

        if (!hashFunction && (!objectToTrack || !_.isFunction(objectToTrack.unwrap))) {
            throw new Error("objectToTrack does not have an unwrap function for the default hash function.");
        }

        function defaultHashFunc(objectToTrack) {
            return ko.toJSON(objectToTrack.unwrap());
        }

        hashFunction = hashFunction || defaultHashFunc;
        var lastCleanState = ko.observable(hashFunction(objectToTrack));

        return {
            somethingHasChanged: function () {
                return hashFunction(objectToTrack) != lastCleanState();
            },
            markCurrentStateAsClean: function () {
                lastCleanState(hashFunction(objectToTrack));
            }
        };
    };

    return ModelChangeTracker;
});
